import { Stack, Typography } from "@mui/material";
import TagManagerGrid from "./datagrid/tag-manager-grid";

export default function TagManager() {
  return (
    <>
      <Stack direction="column" spacing={2} px={"24px"}>
        <TagManagerGrid />
      </Stack>
    </>
  );
}